// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowUpRightAndArrowDownLeft16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-up-right-and-arrow-down-left': IconArrowUpRightAndArrowDownLeft;
    }
}

/**
 * The icon component for the 'arrowUpRightAndArrowDownLeft' icon
 */
export class IconArrowUpRightAndArrowDownLeft extends Icon {
    public constructor() {
        super(arrowUpRightAndArrowDownLeft16X16);
    }
}

registerIcon('icon-arrow-up-right-and-arrow-down-left', IconArrowUpRightAndArrowDownLeft);
export const iconArrowUpRightAndArrowDownLeftTag = 'nimble-icon-arrow-up-right-and-arrow-down-left';
